export const VENDOR_ENDPOINTS = {
  tmsTracking: {
    load: 'https://api-tms.itlabs.io/tms-math/v1/delivery-status',
  },
};
